import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Attachment} from "../../types/attachment";
import {HttpEventType} from "@angular/common/http";
import {Subscription} from "rxjs";
import {AttachmentType} from "../../types/attachment-type";
import {FormService} from "../../services/form.service";
import {MessageService} from "primeng/api";
import {CompanyType} from "../../types/company-type";
import {Company} from "../../types/company";
import {FileUpload} from "primeng/fileupload";
import {Constants} from "../../types/constants";

type AttachmentInternal = {
  attachment : Attachment,
  subscription ?: Subscription
}

@Component({
  selector: 'attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.css']
})
export class AttachmentsComponent implements OnInit {
  @Input() docId !: number;
  @Input() company !: Company;
  @Input() companyType !: CompanyType;
  @Output() krkFileChange = new EventEmitter<Attachment>();
  @Output() paymentFileChange = new EventEmitter<Attachment>();
  @Output() registerFileChange = new EventEmitter<Attachment>();
  @ViewChild('attachmentsForm') attachmentsForm!: NgForm;

  AttachmentType = AttachmentType;
  CompanyType = CompanyType;

  attachmentsFormDirty : boolean = false;
  krkFile ?: Attachment = undefined;
  paymentFile ?: Attachment = undefined;
  registerFile ?: Attachment = undefined;

  constructor(private formService: FormService,
              private messageService: MessageService) {}

  ngOnInit(): void {
    this.attachmentsFormDirty = false;
    this.krkFile = undefined;
    this.paymentFile = undefined;
    this.registerFile = undefined;
  }

  editFormInvalid() : boolean {
    if (this.attachmentsFormDirty &&
        ((this.krkFile == undefined && this.companyType == CompanyType.PHYSICAL)
            || this.paymentFile == undefined
            || this.registerFile == undefined)) {
      return true;
    }
    return false;
  }

  formInvalid() : boolean {
    if ((this.krkFile == undefined && this.companyType == CompanyType.PHYSICAL)
        || this.paymentFile == undefined
        || this.registerFile == undefined)
      return true;
    return false;
  }

  updateAttachment(attachmentType: AttachmentType, attachment ?: Attachment) {
    switch (attachmentType) {
      case AttachmentType.KRK:
        this.krkFile = attachment;
        this.krkFileChange.emit(attachment);
        break;
      case AttachmentType.PAYMENT:
        this.paymentFile = attachment;
        this.paymentFileChange.emit(attachment);
        break;
      case AttachmentType.REGISTER:
        this.registerFile = attachment;
        this.registerFileChange.emit(attachment);
        break;
    }
  }

  uploadHandler(event: any, fileUpload: FileUpload, attachmentType: AttachmentType) {
    if (event.files[0] == undefined)
      return;
    if (attachmentType == AttachmentType.KRK && !this.company.personalData.pesel && !this.company.personalData.identityValue) {
      this.messageService.add({
        severity:'warn',
        detail: "Najpierw podaj pesel lub rodzaj i numer dokumentu właściciela firmy" }
      );
      fileUpload.clear();
      return;
    }
    let attachment: Attachment = {name: event.files[0].name, id: 0};
    this.updateAttachment(attachmentType, attachment);
    fileUpload.disabled = true;
    fileUpload.progress = 0;

    this.formService.uploadFile(event.files[0], this.docId, attachmentType, this.company.personalData?.firstname,
      this.company.personalData?.surname, this.company.personalData?.pesel)
      .subscribe(
        event => {
          if (event.type === HttpEventType.UploadProgress) {
            fileUpload.progress = Math.round(100 * (event.loaded / event.total))
            fileUpload.cd.markForCheck();
          }
          if (event.type === HttpEventType.Response) {
            attachment.id = Number(event.body.message);
            this.updateAttachment(attachmentType, attachment);
          }
        },
        error => {
          this.messageService.add({
            severity: (error.status == 400 && error.error.message != Constants.GenericError) ? 'warn' : 'error',
            detail: error.error.message ?? Constants.GenericError}
          );
          fileUpload.clear();
          fileUpload.uploadedFileCount = 0;
          fileUpload.disabled = false;
          this.updateAttachment(attachmentType, undefined);
        }
      );
  }

  fileRemove(attachmentType: AttachmentType, fileUpload: FileUpload) {
    switch (attachmentType) {
      case AttachmentType.KRK:
        this.krkFile = undefined;
        this.krkFileChange.emit(this.krkFile);
        break;
      case AttachmentType.PAYMENT:
        this.paymentFile = undefined;
        this.paymentFileChange.emit(this.paymentFile);
        break;
      case AttachmentType.REGISTER:
        this.registerFile = undefined;
        this.registerFileChange.emit(this.registerFile);
        break;
    }
    fileUpload.uploadedFileCount = 0;
    fileUpload.disabled = false;
    fileUpload.progress = 0;
  }

  setFormDirty(dirty : boolean) {
    this.attachmentsFormDirty = dirty;
  }

  markFormAsTouched() : void {
    this.attachmentsForm.form.markAllAsTouched();
  }
}
